import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=056f24e7&scoped=true&"
import script from "./Info.vue?vue&type=script&setup=true&lang=js&"
export * from "./Info.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056f24e7",
  null
  
)

export default component.exports